<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <!-- {{ selectedrow }} -->
        <b-card>
          <template #header>
            <h4 class="mb-0">Browse Data</h4>
          </template>
          Tahun: #{{ data.length }}
          <b-form-input
            v-model="tahun"
            type="number"
            class="mb-2"
            size="sm"
            placeholder="Tahun Ajaran"
            @input="initlist()"
          ></b-form-input>
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="selected"
            :options="optionwalas"
            @change="handleGroupChange"
            size="sm"
            style="font-size: 12px"
          ></b-form-checkbox-group>
          <!-- @change="searchUsers(search)" -->

          <!-- {{ selected }} -->
          <b-input-group size="sm">
            <template #append>
              <b-button variant="outline-success" @click="searchUsers(search)">
                <b-icon-search />
              </b-button>
            </template>
            <b-form-input
              placeholder="cari nama santri"
              v-model="search"
              @input="query = search"
              @keydown.enter="searchUsers(search)"
            ></b-form-input>
          </b-input-group>

          <b-table
            small
            :items="data"
            :fields="['foto', 'nis']"
            hover
            @row-clicked="dataselected"
            :tbody-tr-class="rowClass"
            sticky-header="300px"
            class="mt-2"
            style="font-size: 12px"
          >
            <template #cell(pasfoto)="row">
              {{ row.item.pasfoto }}
            </template>
            <template #cell(foto)="row">
              <!-- :src="$appUrl + row.item.pasfoto" -->
              <b-img :src="getSrc(row.item.pasfoto)" width="60px" rounded />
            </template>
            <template #cell(nis)="row">
              {{ row.item.nis }}<br />{{ row.item.nama }} <br />
              [{{ row.item.noasrama }}-{{ row.item.namaasrama }}]
            </template>
          </b-table>
        </b-card>
      </div>
      <div class="col-md-9">
        <b-card>
          <template #header>
            <h4 class="mb-0">Report Santri</h4>
          </template>
          Report NIS: {{ selectedrow }} <b>{{ nama }}</b
          ><br />
          <b-table
            :items="infosantri"
            :fields="[
              'namapmb',
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
              'rating',
            ]"
            small
            hover
            responsive
            style="font-size: 12px"
            :busy="isBusy"
          >
            <template
              v-for="(month, index) in months"
              v-slot:[`head(${month})`]
            >
              <div class="text-dark text-right" :key="index">
                {{ $func.titleCase(month) }}
              </div>
            </template>
            <template
              v-for="(month, index) in months"
              v-slot:[`cell(${month})`]="{ item }"
            >
              <div class="text-right" :key="index">
                <a href="javascript:void(0)" @click="detail(item, index + 1)">
                  {{ item[month] }}</a
                >
              </div>
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
          IBADAH Santri NIS:{{ selectedrow }} <b>{{ nama }}</b>
          <b-table
            :items="penilaian"
            :fields="[
              'keterangan',
              'bulan',
              'jml',
              'tg01',
              'tg02',
              'tg03',
              'tg04',
              'tg05',
              'tg06',
              'tg07',
              'tg08',
              'tg09',
              'tg10',
              'tg11',
              'tg12',
              'tg13',
              'tg14',
              'tg15',
              'tg16',
              'tg17',
              'tg18',
              'tg19',
              'tg20',
              'tg21',
              'tg22',
              'tg23',
              'tg24',
              'tg25',
              'tg26',
              'tg27',
              'tg28',
              'tg29',
              'tg30',
              'tg31',
            ]"
            small
            hover
            responsive
            style="font-size: 12px"
            :busy="isBusy"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-card>
      </div>
    </div>
    <b-modal ref="my-modal" size="lg" title="Data Detail PMB" scrollable>
      <b-table
        :items="detailpmb"
        :fields="['tanggal', 'keterangan', 'catatan', 'hadir', 'rating']"
        small
        hover
        responsive
        style="font-size: 12px"
      ></b-table>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  name: "Report",
  components: {
    //  Navbar,
  },
  data() {
    return {
      data: [],
      infosantri: [],
      penilaian: [],
      detailpmb: [],
      optionwalas: [],
      password: "",
      ketlogin: "",
      query: "",
      search: "",
      selectedrow: "",
      profileImage: null,
      indexdata: 0,
      isBusy: false,
      nis: "",
      nama: "",
      tahun: this.$globalData.CurrentYear,
      keterangan: "",
      selected: [],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  watch: {
    // When the query value changes, fetch new results from
    // the API - in practice this action should be debounced
    query: _.debounce(function (newQuery) {
      this.searchUsers(newQuery);
    }, 300),
  },
  mounted() {
    this.initlist();
  },

  methods: {
    initlist() {
      if (this.$globalData.LevelLogin != "9") {
        axios
          .get(
            this.$appUrl +
              "listwalasreport.php??token=" +
              this.$globalData.Token +
              "&tahun=" +
              this.tahun +
              "&level=" +
              this.$globalData.LevelLogin +
              "&user=" +
              this.$globalData.UserId
          )
          .then((res) => {
            this.optionwalas = res.data;
            // console.log("data search", this.data);
            // this.selected = this.optionwalas.map((o) => o.value); //all data selected
            this.selected =
              this.optionwalas.length > 0 ? [this.optionwalas[0].value] : [];
            this.searchUsers(this.search);
          });
      }
    },
    handleGroupChange(newSelected) {
      // Pisahkan berdasarkan prefix
      const assItems = newSelected.filter((val) => val.startsWith("ASS-"));
      const otherItems = newSelected.filter((val) => !val.startsWith("ASS-"));

      if (assItems.length > 0 && otherItems.length > 0) {
        // Jika campur antara ASS dan non-ASS, tolak perubahan terakhir
        this.$bvToast.toast("ASS tidak bisa digabung dengan MRJ atau PMB.", {
          title: "Peringatan",
          variant: "danger",
          solid: true,
        });

        // Tentukan grup yang aktif sebelumnya
        const prevASS = this.selected.every((val) => val.startsWith("ASS-"));
        // const prevNonASS = this.selected.every(
        //   (val) => !val.startsWith("ASS-")
        // );

        // Kembalikan ke grup lama (tanpa item baru yang melanggar aturan)
        this.selected = prevASS ? assItems : otherItems;
      } else {
        // Tidak ada konflik, izinkan
        this.selected = newSelected;
      }
      this.searchUsers(this.search);
    },

    detail(item, bln) {
      console.log("detail item", item);
      axios
        .get(
          this.$appUrl +
            "reportdetail.php?nis=" +
            item.nis +
            "&token=" +
            this.$globalData.Token +
            "&pmb=" +
            item.nopmb +
            "&tahun=" +
            "2425" +
            "&bulan=" +
            bln
        )
        .then((res) => {
          console.log("detail report", res.data);
          this.detailpmb = res.data;
          this.$refs["my-modal"].show();
        });
      //   this.getinfosantri(item.nis);
    },
    addsantri(nis, nama, keterangan) {
      if (nis == "" || nama == "") {
        this.$toast.error("NIS dan Nama tidak boleh kosong", {
          type: "danger",
          position: "top-right",
          duration: 3000,
          dismissible: true,
        });
        return;
      }
      axios
        .get(
          this.$appUrl +
            "addsantri.php?nis=" +
            nis +
            "&nama=" +
            nama +
            "&keterangan=" +
            keterangan +
            "&token=" +
            this.$globalData.Token
        )
        .then((res) => {
          if (res.data.status == "NO") {
            this.$bvModal.msgBoxOk(
              nis + " " + res.data.nama + " Sudah ada...."
            );
            this.$refs.modal_plus_santri.hide();
            return;
          }
          console.log(res.data);
          this.$toast.success("Data Save Sukses", {
            type: "success",
            position: "top-right",
            duration: 3000,
            dismissible: true,
          });
          axios
            .get(
              this.$appUrl +
                `searchsiswa.php?q=${nis}` +
                "&token=" +
                this.$globalData.Token
            )
            .then((res) => {
              this.data = res.data;
              console.log("data search", this.data);
              this.dataselected(this.data[0], 0, null);
            });

          this.$refs.modal_plus_santri.hide();
        });
    },
    resetpassword() {
      this.$bvModal
        .msgBoxConfirm("Yakin Password untuk di Reset ?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okTitle: "YES",
          cancelTitle: "NO",
          noCloseOnBackdrop: true,
        })
        .then((value) => {
          if (value) {
            axios
              .get(
                this.$appUrl +
                  "resetpassword.php?nis=" +
                  this.selectedrow +
                  "&token=" +
                  this.$globalData.Token
              )
              .then((res) => {
                console.log(res.data);
              });
          }
        });
    },
    getSrc(pasfoto) {
      // Jika 4 digit pertama dari pasfoto adalah 'blob', maka gunakan hanya nama pasfoto
      if (pasfoto && pasfoto.startsWith("blob")) {
        return pasfoto;
      } else {
        // Jika bukan, gabungkan dengan $appUrl
        return this.$appUrl + pasfoto;
      }
    },
    dataselected(item, index, event) {
      console.log("row select", item, index, event);
      this.indexdata = index;
      this.selectedrow = item.nis;
      this.nama = item.nama;
      this.isBusy = true;
      axios
        .get(
          this.$appUrl +
            "report.php?nis=" +
            item.nis +
            "&token=" +
            this.$globalData.Token +
            "&kelas=" +
            item.nokelas +
            "&tahun=" +
            this.tahun +
            "&kode=" +
            item.noasrama
        )
        .then((res) => {
          this.infosantri = res.data.datapmb;
          this.penilaian = res.data.datapenilaian;
          console.log("infosantri", this.infosantri);
          this.isBusy = false;
        });
    },
    getinfosantri(nis) {
      this.isBusy = true;
      axios
        .get(
          this.$appUrl +
            "getinfosantri.php?nis=" +
            nis +
            "&token=" +
            this.$globalData.Token
        )
        .then((res) => {
          this.infosantri = res.data;
          this.isBusy = false;
        });
    },
    openFileInput() {
      // Klik input file saat gambar diklik
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const uploadedFile = event.target.files[0];
      // Gunakan URL.createObjectURL() untuk menampilkan gambar yang dipilih oleh pengguna secara langsung
      // let tg = new Date();
      this.profileImage = URL.createObjectURL(uploadedFile);
      this.data[this.indexdata].pasfoto = this.profileImage;
      console.log(
        "Profile Image",
        this.data[this.indexdata].pasfoto,
        this.profileImage
      );
      this.uploadfile(uploadedFile);
    },
    uploadfile(nf) {
      // console.log("uploadfile", nf, th, index);
      //   this.valuedownload = 0;
      var config = {
        onUploadProgress: (progressEvent) => {
          // ini harus menggunakan arrow function
          console.log("progress event", progressEvent);
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.valuedownload = percentCompleted;
          console.log("progress", percentCompleted, this.valuedownload);
        },
        headers: {
          "Content-Type": "multipart/header-data",
        },
      };
      var data = new FormData();
      data.append("userid", this.selectedrow);
      data.append("file", nf);
      axios
        .post(
          this.$appUrl + "uploadfotosantri.php?token=" + this.$globalData.Token,
          data,
          config
        )
        .then((res) => {
          //  th.target.innerText = res.data.status;
          this.dok = null;
          this.$toast.success(res.data.status, {
            type: "success",
            position: "top-right",
            duration: 3000,
            dismissible: true,
          }); //   output.className = 'container';
          //   output.innerHTML = res.data;
        })
        .catch(function (err) {
          console.log("error", err);
          //   output.className = 'container text-danger';
          //   output.innerHTML = err.message;
        });
    },
    updatedata(nis, nama, field) {
      console.log("updatte", nis, nama, field);
      axios
        .get(
          this.$appUrl +
            "updatesantri.php?nis=" +
            nis +
            "&value=" +
            nama +
            "&field=" +
            field +
            "&token=" +
            this.$globalData.Token
        )
        .then((res) => {
          console.log(res);
          // this.data[this.indexdata][field] = nama;
        });
    },
    searchUsers(newQuery) {
      axios
        .post(
          this.$appUrl +
            `searchsiswareport.php?q=${newQuery}` +
            "&token=" +
            this.$globalData.Token +
            "&tahun=" +
            this.tahun +
            "&level=" +
            this.$globalData.LevelLogin +
            "&user=" +
            this.$globalData.UserId,
          this.selected
        )
        .then((res) => {
          this.data = res.data;
          console.log("data search", this.data);
          this.penilaian = [];
          this.detailpmb = [];
          this.infosantri = [];
        });
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.nis === this.selectedrow) return "table-success";
    },
  },
  filters: {
    uppercase(value) {
      return value.toUpperCase();
    },
  },
};
</script>

<style>
.bold-input {
  font-weight: bold !important;
}
</style>
